// extracted by mini-css-extract-plugin
export default {"paymentHistoryTable":"iX61no4mYVGW5q5p8OUj"};